// General
export const APP_VERSION = import.meta.env.VITE_APP_VERSION;
export const APP_ENV = import.meta.env.VITE_ENV;


export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const SHOPIFY_CLIENT_ID = import.meta.env.VITE_SHOPIFY_CLIENT_ID;
export const SHOPIFY_SCOPE = import.meta.env.VITE_SHOPIFY_SCOPE;
export const SEGMENT_KEY = import.meta.env.VITE_SEGMENT_KEY;
export const SENTRY_DNS = import.meta.env.VITE_SENTRY_DNS;
export const KLAVIYO_SCOPE = import.meta.env.VITE_KLAVIYO_SCOPE;
export const KLAVIYO_CLIENT_ID = import.meta.env.VITE_KLAVIYO_CLIENT_ID;
export const HOTJAR_SITE_ID = import.meta.env.VITE_HOTJAR_SITE_ID;
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const GOOGLE_AUTH_CLIENT_ID = import.meta.env.VITE_GOOGLE_AUTH_CLIENT_ID;
export const PADDLE_ENVIRONMENT = import.meta.env.VITE_PADDLE_ENVIRONMENT;
export const PADDLE_TOKEN = import.meta.env.VITE_PADDLE_TOKEN;
export const PUBLIC_POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
export const PUBLIC_POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;
export const TIKTOK_APP_ID = import.meta.env.VITE_TIKTOK_APP_ID;
export const LINKEDIN_CLIENT_ID = import.meta.env.VITE_LINKEDIN_CLIENT_ID;

// Dev-only: render the enrichment fixture when real fields are absent. Never on in prod.
export const ENRICHMENT_MOCK = import.meta.env.VITE_ENRICHMENT_MOCK === 'true'
